import { render, staticRenderFns } from "./TaskCard.vue?vue&type=template&id=8b42a128&scoped=true&"
import script from "./TaskCard.vue?vue&type=script&lang=js&"
export * from "./TaskCard.vue?vue&type=script&lang=js&"
import style0 from "./TaskCard.vue?vue&type=style&index=0&id=8b42a128&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b42a128",
  null
  
)

export default component.exports